export function makePassportUrl(passportServer) {
    return {
        oauth: {
            login: passportServer + '/oauth2/authorization',
            redirect: passportServer + '/login/oauth2/code',
        },
        saml: {
            base: passportServer,
            ssoUrl: passportServer + '/saml/SSO',
            samlLogin: passportServer + '/saml/login',
        },
        public: {
            base: passportServer,
            forget: passportServer + '/public/forget',
            getIdps: passportServer + '/public/institution/idps',
            getPublicKey: passportServer + '/public/request_public_key',
            preLogin: passportServer + '/public/pre_login',
            getMfaCk: passportServer + '/public/mfa/ck',
        },
    };
}
